import { api } from "../api";

export const deleteQuestionnaireTemplate = async (questionnaireTemplateId: string): Promise<void> => {
  await api.services.questionnaireTemplates.deleteQuestionnaireTemplate(questionnaireTemplateId);
};
